import React, { Component } from "react";
import { flattenErrors } from './ErrorHelpers';
import moment from 'moment';

const Notification = ({ id, title, body, date, snoozable, action, icon }) => (
    <div key={id} className="notifications-item">
        <div className="notifications-item-icon">
            <i className={"fa " + (icon == undefined ? "fa-bell" : icon)}></i>
        </div>
        <div className="text">
            <h4>{title}</h4>
            <p>{body}</p>
        </div>
    </div >
);

export class TalentNotificationsProfileComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {
        };
    }

    dismiss = (e) => {
        e.preventDefault();
        let notyId = e.target.value;
        this.dismissNotification(notyId);
    };

    dismissAll = (e) => {
        let dismissables = this.state.notys.filter(function (value, index, arr) { return value.snoozable });
        let dismissFn = this.dismissNotification;

        if (dismissables.length) {
            dismissables.forEach(
                function (noty) {
                    dismissFn(noty.id);
                });
        }
    };

    dismissNotification = (id) => {
        fetch(`/api/talent/notifications/${id}/dismiss`,
            {
                method: "POST"
            })
            .then(resp => {
                if (resp.ok) {
                    let newNotyState = this.state.notys.filter(function (value, index, arr) { return value.id.toString() != id });
                    this.setState({
                        notys: newNotyState
                    });
                }
            });
    }

    getNotifications = (start, count) => {

        fetch(`/api/talent/${this.props.accountNumber}/notifications?start=${start}&count=${count}`,
            {
                method: "GET",
            })
            .then(req => req.json())
            .then(resp => {
                if (resp.length) {
                    this.setState({
                        notys: resp
                    });
                }
            });
    }

    componentDidMount() {
        this.getNotifications(0, 10);
    }

    render() {
        return (
            <>
                <div className="d-flex">
                    {<img id="noty-pic" class="profile-pic-mbl img-fluid" src={this.props.photoUrl} alt="" />}
                    {this.state.notys &&
                        <div className="noty-charm-pic">{this.state.notys.filter(n => !n.read).length}</div>
                    }
                </div>
                <div className="notifications-mbl" id="box-mbl">
                    <h2>Notifications
                        <input class="btn btn-sm btn-primary float-right pWindow" type="button" value="New Profile Image" />
                    </h2>

                    {this.state.notys &&

                        this.state.notys.map((noty) => (
                            <Notification
                                id={noty.id}
                                title={noty.title}
                                body={noty.body}
                                date={noty.showPopupOnDateTimeUtc}
                                snoozable={noty.snoozable}
                                action={noty.notificationAction}
                            />
                        ))}

                </div>
            </>
        );
    }
}